import React from 'react'
import UserSquareIcon from '../../../component/icons/user-square';
import Umbrella3Icon from '../../../component/icons/umbrella3';
import CalendarIcon from '../../../component/icons/calendar';
import ClockPlusIcon from '../../../component/icons/clock-plus';
import Trophy1Icon from '../../../component/icons/trophy-1';
import BookmarkCheckIcon from '../../../component/icons/bookmark-check';
import FolderIcon from '../../../component/icons/folder';
import Dataflow3Icon from '../../../component/icons/dataflow-3';
import FileCheck3Icon from '../../../component/icons/file-check-3';
import LayerTwo1Icon from '../../../component/icons/layer-two-1';
import LetterSpacing1Icon from '../../../component/icons/letter-spacing-1';
import CoinsStacked2Icon from '../../../component/icons/coins-stacked-2';
import { Link } from 'react-router';
import { BookUser, Gem, HatGlasses, Package, Users } from 'lucide-react';

const listing = [
    { icon: <UserSquareIcon />, icon_background: '#FEF7E6', icon_forground: '#D02533', label: "Clients", url: '/operations/client/overview' },
    { icon: <HatGlasses/>, icon_background: '#F4F8EB', icon_forground: '#D02533', label: "Agents", url: '/operations/agents/overview' },
    { icon: <BookUser />, icon_background: '#F4F8EB', icon_forground: '#D02533', label: "Account Manager", url: '/operations/account-manager' },
    { icon: <FileCheck3Icon />, icon_background: 'rgba(251, 55, 72, 0.10)', icon_forground: '#D02533', label: "Teams", url: '/operations/team/overview' },
    { icon: <Gem/>, icon_background: '#FDF1EC', icon_forground: '#D02533', label: "Brands", url: "/operations/brand/overview" },
    { icon: <BookmarkCheckIcon />, icon_background: '#EEF4FF', icon_forground: '#D02533', label: "Products", url: '/operations/product/product-list' },
    { icon: <Package/>, icon_background: '#FEF4E5', icon_forground: '#D02533', label: "Packages", url: "/operations/package/overview" },
    { icon: <Users/>, icon_background: '#EFFBFF', icon_forground: '#D02533', label: "Merchants", url: "/operations/merchant/overview" },
    { icon: <FolderIcon />, icon_background: '#EFFBFF', icon_forground: '#D02533', label: "Lost Deals Reasons", url: '/operations/lost-deals/lost-deal' },
    // { icon: <Dataflow3Icon />, icon_background: '#FAEAF3', icon_forground: '#D02533', label: "Your Devices", url: '/devices/device' },
    // { icon: <CoinsStacked2Icon />, icon_background: '#EFFBFF', icon_forground: '#D02533', label: "Compensation", url: '/' },
];

const SettingsOperations = ({Style}) => {
    return (
        <div className={Style.orgOverLocation_grid}>
            {listing.map((item) => (
                <Link to={item.url} className={Style.orgOverLocation_items} key={item.label}>
                    <span className={Style.icon} style={{ backgroundColor: (item?.icon_background) ? item?.icon_background : '', color: (item?.icon_forground) ? item?.icon_forground : '' }}>{item.icon}</span>
                    <span className={Style.label}>{item.label}</span>
                </Link>
            ))}
        </div>
    )
}

export default SettingsOperations
